import React from 'react';
import { Box, Typography } from '@mui/material';
import PermissionGate from '@/__core/permissions/components/PermissionGate';

interface InventoryPermissionGuardProps {
  permissions: Array<{ resource: string; action: string }>;
  children: React.ReactNode;
}

export default function InventoryPermissionGuard({ permissions, children }: InventoryPermissionGuardProps) {
  return (
    <PermissionGate
      permissions={permissions}
      fallback={(
        <Box sx={{ p: 3 }}>
          <Typography variant='h6' sx={{ fontWeight: 600, mb: 1 }}>
            Khong co quyen truy cap
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            Ban khong duoc cap quyen de su dung chuc nang kho nay.
          </Typography>
        </Box>
      )}
    >
      {children}
    </PermissionGate>
  );
}
